import { render, staticRenderFns } from "./wechatGroup.vue?vue&type=template&id=70ff0766&scoped=true"
import script from "./wechatGroup.vue?vue&type=script&lang=js"
export * from "./wechatGroup.vue?vue&type=script&lang=js"
import style0 from "./wechatGroup.vue?vue&type=style&index=0&id=70ff0766&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff0766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ff0766')) {
      api.createRecord('70ff0766', component.options)
    } else {
      api.reload('70ff0766', component.options)
    }
    module.hot.accept("./wechatGroup.vue?vue&type=template&id=70ff0766&scoped=true", function () {
      api.rerender('70ff0766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/wechatGroup.vue"
export default component.exports